import { useQuery } from '@tanstack/react-query';
import backend from '../../services/backend';

export function useProjectGraph(projectId: string | undefined) {
  return useQuery({
    queryKey: ['getProjectGraph', projectId],
    queryFn: () => backend.getProjectGraph(projectId as string).then((res) => res.data),
    enabled: !!projectId,
    staleTime: 30_000,
  });
}
